const domainList = [
  {
    name: "UcantayB2b",
    path: "b2b.ucantay.com",
    localPath: "/b2bUcantayLogin",
    loginPage: "/pages/ucantayLogin",
    component: () =>
      import(
        /*webpackChunkName:"ucantayLogin"*/ "@/views/pages/ucantayLogin.vue"
      ),
  },
  {
    name: "Dev - B2B",
    path: "dev-b2b.d7ksuper.com",
    localPath: "/b2bUcantayLogin",
    loginPage: "/pages/ucantayLogin",
    component: () =>
      import(
        /*webpackChunkName:"ucantayLogin"*/ "@/views/pages/ucantayLogin.vue"
      ),
  },
  {
    name: "Etisan",
    path: "etisan.d7ksuper.com",
    localPath: "/etisanLogin",
    loginPage: "/pages/etisanLogin",
    component: () =>
      import(
        /*webpackChunkName:"etisanLogin"*/ "@/views/pages/etisanLogin.vue"
      ),
  },
  {
    name: "Farhym",
    path: "panel.farhym.com",
    localPath: "/farhymLogin",
    loginPage: "/pages/farhymLogin",
    component: () =>
      import(
        /*webpackChunkName:"farhymLogin"*/ "@/views/pages/farhymLogin.vue"
      ),
  },
  {
    name: "Faraero",
    path: "panel.faraero.com.tr",
    localPath: "/faraeroLogin",
    loginPage: "/pages/faraeroLogin",
    component: () =>
      import(
        /*webpackChunkName:"faraeroLogin"*/ "@/views/pages/faraeroLogin.vue"
      ),
  },
  {
    name: "Plasten",
    path: "panel.plasten.com",
    localPath: "/plastenLogin",
    loginPage: "/pages/plastenLogin",
    component: () =>
      import(
        /*webpackChunkName:"plastenLogin"*/ "@/views/pages/plastenLogin.vue"
      ),
  },
];
export default domainList;
